import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { swiperConfig } from '../lib/swiper-config.js';
import { mountEvents } from '../lib/swiper-events.js';
import {axClient} from "@/secured/mixins/axios-mixins";

Vue.use(VueAwesomeSwiper);

Vue.component('swiper-exhibitors-logos', {
    data: function () {
        return {
            logos: [],
            options: {
                ...swiperConfig,
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 0,
                loop: true,
                loopFillGroupWithBlank: true,
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: true
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            optionsLg: {
                ...swiperConfig,
                slidesPerView: 1,
                spaceBetween: 20,
                slidesPerGroup: 1,
                loop: false,
                loopFillGroupWithBlank: false,
                navigation: {
                    nextEl: '.swiper-next-btn',
                    prevEl: '.swiper-prev-btn'
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    992: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                },
                pagination: {
                    el: '.swiper-pagination.sr-only',
                    clickable: true
                },
            },
        }
    },
    mounted() {
        let vm = this;
        axClient.apiGet("/exhibitors/logos", function(resp) {
            resp.data.forEach(function(it) {
                vm.logos.push(it);
            });
        });
        mountEvents(this.$el, this.$refs.swiperExhibitorsLogos)
    }
});


